<div class="container">
    <mat-form-field>
        <mat-label>{{ name }}</mat-label>
        <input matInput [(ngModel)]="inputTxt">
    </mat-form-field>
    <div class="buttons">
        <button mat-button (click)="onClickAdd()">Add</button>
        <button mat-button (click)="onClickDelete()">Delete</button>
    </div>
    <div class="selections">
        <mat-checkbox *ngFor="let n of Selections" (change)="onChangeChk($event)" [checked]="n.value" [id]="n.text">{{ n.text }}</mat-checkbox>
    </div>
</div>
